import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/pago/ko")({
  head: () => ({ meta: [{ title: "Pago no completado · El Pajar de Benito" }, { name: "robots", content: "noindex" }] }),
  component: PagoKo,
});

function PagoKo() {
  return (
    <section className="mx-auto max-w-xl px-4 py-24 text-center">
      <p className="text-xs uppercase tracking-[0.28em] text-accent">Pago no completado</p>
      <h1 className="mt-3 font-serif text-4xl text-foreground">El pago no se ha completado</h1>
      <p className="mt-5 text-muted-foreground">
        Puedes volver a intentarlo o contactarnos por WhatsApp si necesitas ayuda.
      </p>
      <Link to="/reserva" className="mt-8 inline-block rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90">
        Volver a la reserva
      </Link>
    </section>
  );
}